<template>
    <console-content class="pa-4">
        <v-row class="ma-n2">
            <v-col class="pa-2" cols="12">
                <dashboard-table type='day' />
            </v-col>
            <v-col class="pa-2" cols="12">
                <dashboard-table type='month' />
            </v-col>
        </v-row>
    </console-content>
</template>
<script>
import ConsoleContent from "@/pages/console/templates/ConsoleContent.vue";
import DashboardTable from "@/components/console/dashboard/dashboard-table.vue";

export default {
    components: {
        ConsoleContent,
        DashboardTable,
    },
};
</script>
